module.exports = __webpack_public_path__ + "static/img/CoTextCorp-Regular.69e4ec3.svg";